/** Competências fixas para desenvolvimento pessoal (combobox). */
export const PERSONAL_DEVELOPMENT_COMPETENCIES = [
  { value: 'Ousadia', label: 'Ousadia' },
  { value: 'Persuasão', label: 'Persuasão' },
  { value: 'Empatia', label: 'Empatia' },
  { value: 'Organização', label: 'Organização' },
  { value: 'Comando', label: 'Comando' },
  { value: 'Extroversão', label: 'Extroversão' },
  { value: 'Paciência', label: 'Paciência' },
  { value: 'Detalhismo', label: 'Detalhismo' },
  { value: 'Objetividade', label: 'Objetividade' },
  { value: 'Entusiasmo', label: 'Entusiasmo' },
  { value: 'Persistência', label: 'Persistência' },
  { value: 'Prudência', label: 'Prudência' },
  { value: 'Assertividade', label: 'Assertividade' },
  { value: 'Sociabilidade', label: 'Sociabilidade' },
  { value: 'Planejamento', label: 'Planejamento' },
  { value: 'Concentração', label: 'Concentração' },
] as const;

export function isPersonalDevelopmentCompetency(value: string): boolean {
  return PERSONAL_DEVELOPMENT_COMPETENCIES.some((c) => c.value === value);
}
